<template>
  <div class="flex -mx-3">
    <div class="w-24 px-3">
      <RouterLink
        :to="{ name: 'accounts.show', params: { accountId: account.id } }"
        class="capitalize"
      >
        <template v-if="account.logo">
          <img :src="account.logo" class="block rounded w-full" />
        </template>
        <template v-else>
          <div class="aspect-ratio-square w-full rounded bg-gray-200" />
        </template>
      </RouterLink>
    </div>
    <div class="flex-1 px-3">
      <RouterLink
        :to="{ name: 'accounts.show', params: { accountId: account.id } }"
        class="capitalize"
      >
        <h3 class="text-sm font-medium text-gray-900">{{ account.name }}</h3>
      </RouterLink>
    </div>
    <div v-if="$isAdminOrSuperAdmin" class="flex-1 px-3 text-gray-900 text-sm">
      {{ membershipProductName }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'DataIteratItem',
  props: {
    account: {
      type: Object,
      required: true,
    },
  },
  computed: {
    membershipProductName() {
      if (typeof this.account.membershipProduct === 'undefined') {
        return 'Not available';
      }

      if (!this.account.membershipProduct) {
        return '-';
      }

      return this.account.membershipProduct?.name || 'Product name not available';
    },
  },
};
</script>
